<template>
  <div class="text-center">
    <v-dialog
      v-model="display"
      :width="width"
    >
      <v-card v-if="display" class="device-selector-container">
        <v-row>
          <v-col cols="12" class="remove-padding">
            <div class="heading-info" :style="headingWidth">
              <div class="vehicle-icon">
                <v-icon color="white">mdi-car</v-icon>
              </div>
              <h4> {{ panelHeading }} </h4>
              <v-icon 
                large 
                color="red"
                class="close-btn"
                @click.native="closeModal">
                mdi-close
              </v-icon>
            </div>
          </v-col>
          
          <v-col cols="12">
            <slot />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
export default {
  name: 'InfoContainer',
  props: {
    display: {
      type: Boolean,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    panelHeading: {
      type: String,
      required: true
    }
  },
  computed: {
    headingWidth() {
      return `width: ${this.width}px !important;`
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    }
  }
}
</script>

<style lang="scss">
.device-selector-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  box-shadow: 10px !important;
  .wrapper {
    overflow-y: auto;
    height: 100%;
    width: 100%;
    padding: 0;
  }
  .close-btn {
    position: absolute;
    z-index: 50;
    top: 0;
    right: 0;
    cursor: pointer;
  }
  .heading-info {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #0f74bb;
    z-index: 40;
    height: 40px;
    color: white;
    left: 50%;
    transform: translate(-50%, 0);
    h3 {
      margin: 0 !important;
    }
  }
}
</style>